import { AddressData } from 'src/dtos/applicationData'

export const buildFormattedAddress = (data: AddressData) => {
  const { addressComponents } = data
  
  if(!!addressComponents) {
    
    const streetNumber = addressComponents?.find(item => item?.types?.includes('street_number'))?.shortName ?? ''
    const route = addressComponents?.find(item => item?.types?.includes('route'))?.shortName ?? ''
    const subpremise = addressComponents?.find(item => item?.types?.includes('subpremise'))?.shortName ?? ''
    const locality = addressComponents?.find(item => item?.types?.includes('locality'))?.shortName ?? ''
    const postalCode = addressComponents?.find(item => item?.types?.includes('postal_code'))?.shortName ?? ''
    const stateCode = addressComponents?.find(item => item?.types?.includes('state'))?.shortName ?? ''

    const parts = [
      `${streetNumber} ${route}`,
      subpremise,
      locality,
      `${stateCode} ${postalCode}`      
    ];
    const formatted = parts
      .map(o => o.trim())
      .filter(o => o.length > 0)
      .join(', ')
    return formatted;
  }

  return ''
}

export function isPopulatedString(str?: string): boolean {
  if (typeof str !== "string") { return false; }
  if (str.length == 0) { return false; }
  return true;
}